import { PolicyViewerScreen } from '@/features/policy-acceptance';

export default function PrivacyPolicyRoute() {
  return <PolicyViewerScreen policyType="PRIVACY_POLICY" />;
}
